// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Data_Bounded = require("../Data.Bounded/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Exists = require("../Data.Exists/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List_Lazy_NonEmpty = require("../Data.List.Lazy.NonEmpty/index.js");
var Data_List_Lazy_Types = require("../Data.List.Lazy.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Extra_Prelude = require("../Extra.Prelude/index.js");
var DiffTime = function (x) {
    return x;
};
var Ap = function (x) {
    return x;
};
var ExAp = function (x) {
    return x;
};
var Animated = function (x) {
    return x;
};
var Animating = (function () {
    function Animating(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Animating.create = function (value0) {
        return function (value1) {
            return new Animating(value0, value1);
        };
    };
    return Animating;
})();
var AnimatingAp = (function () {
    function AnimatingAp(value0) {
        this.value0 = value0;
    };
    AnimatingAp.create = function (value0) {
        return new AnimatingAp(value0);
    };
    return AnimatingAp;
})();
var wrapInstant = function ($87) {
    return Extra_Prelude.unsafeFromJust(Data_DateTime_Instant.instant(Data_Time_Duration.Milliseconds($87)));
};
var unwrapInstant = (function () {
    var $88 = Data_Newtype.un(Data_Time_Duration.newtypeMilliseconds)(Data_Time_Duration.Milliseconds);
    return function ($89) {
        return $88(Data_DateTime_Instant.unInstant($89));
    };
})();
var singleton = function (duration) {
    return function (value) {
        return Data_List_Lazy_NonEmpty.singleton({
            duration: duration,
            value: value
        });
    };
};
var semiringDiffTime = Data_Semiring.semiringNumber;
var $$static = function (x) {
    return Control_Applicative.pure(Data_List_Lazy_Types.applicativeNonEmptyList)({
        duration: Data_Semiring.zero(semiringDiffTime),
        value: Data_Function["const"](x)
    });
};
var plus = function (s) {
    return function (v) {
        return wrapInstant(unwrapInstant(s) + v);
    };
};
var ordDiffTime = Data_Ord.ordNumber;
var newtypeDiffTime = new Data_Newtype.Newtype(function (n) {
    return n;
}, DiffTime);
var newtypeAnimated = new Data_Newtype.Newtype(function (n) {
    return n;
}, Animated);
var minus = function (start) {
    return function (end) {
        return DiffTime(unwrapInstant(start) - unwrapInstant(end));
    };
};
var getStatic = function (v) {
    return function (v1) {
        if (v1 instanceof AnimatingAp) {
            return Data_Maybe.Nothing.value;
        };
        if (v1 instanceof Animating) {
            var v2 = Data_List_Lazy_NonEmpty.head(v1.value1);
            var $38 = Data_Ord.lessThan(ordDiffTime)(minus(v)(v1.value0))(v2.duration);
            if ($38) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(v2.value(v2.duration));
        };
        throw new Error("Failed pattern match at Animation.Core (line 86, column 1 - line 86, column 57): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var functorExAp = function (dictFunctor) {
    return new Data_Functor.Functor(function (f) {
        return function (v) {
            return ExAp(Data_Exists.runExists(function (v1) {
                var fn$prime = Data_Functor.map(dictFunctor)(function (g) {
                    return function ($90) {
                        return f(g($90));
                    };
                })(v1.fn);
                return Data_Exists.mkExists({
                    fn: fn$prime,
                    value: v1.value
                });
            })(v));
        };
    });
};
var functorAnimated = new Data_Functor.Functor(function (f) {
    return function (m) {
        return Data_Functor.map(Data_List_Lazy_Types.functorNonEmptyList)(function (o) {
            return {
                value: Data_Functor.map(Data_Functor.functorFn)(f)(o.value),
                duration: o.duration
            };
        })(m);
    };
});
var functorAnimating = new Data_Functor.Functor(function (f) {
    return function (m) {
        if (m instanceof Animating) {
            return new Animating(m.value0, Data_Functor.map(functorAnimated)(f)(m.value1));
        };
        if (m instanceof AnimatingAp) {
            return new AnimatingAp(Data_Functor.map(functorExAp(functorAnimating))(f)(m.value0));
        };
        throw new Error("Failed pattern match at Animation.Core (line 77, column 1 - line 77, column 54): " + [ m.constructor.name ]);
    };
});
var eqDiffTime = Data_Eq.eqNumber;
var applyClamped = function (bound) {
    return function (f) {
        return function (t) {
            var $53 = Data_Ord.lessThan(ordDiffTime)(t)(Data_Semiring.zero(semiringDiffTime));
            if ($53) {
                return f(Data_Semiring.zero(semiringDiffTime));
            };
            var $54 = Data_Ord.greaterThan(ordDiffTime)(t)(bound);
            if ($54) {
                return f(bound);
            };
            return f(t);
        };
    };
};
var unsafeResolve = function (t) {
    return function (v) {
        if (v instanceof AnimatingAp) {
            return Data_Exists.runExists(function (v1) {
                return unsafeResolve(t)(v1.fn)(unsafeResolve(t)(v1.value));
            })(v.value0);
        };
        if (v instanceof Animating) {
            var v1 = Data_List_Lazy_NonEmpty.head(v.value1);
            return applyClamped(v1.duration)(v1.value)(minus(t)(v.value0));
        };
        throw new Error("Failed pattern match at Animation.Core (line 130, column 1 - line 130, column 55): " + [ t.constructor.name, v.constructor.name ]);
    };
};
var applyAnimating = new Control_Apply.Apply(function () {
    return functorAnimating;
}, function (fn) {
    return function (value) {
        return AnimatingAp.create(ExAp(Data_Exists.mkExists({
            fn: fn,
            value: value
        })));
    };
});
var applicativeAnimating = new Control_Applicative.Applicative(function () {
    return applyAnimating;
}, function (x) {
    return new Animating(Data_Bounded.bottom(Data_DateTime_Instant.boundedInstant), $$static(x));
});
var prune = function (now) {
    return function (v) {
        if (v instanceof Animating) {
            var v1 = Data_List_Lazy_NonEmpty.uncons(v.value1);
            var v2 = Data_List_Lazy_NonEmpty.fromList(v1.tail);
            if (v2 instanceof Data_Maybe.Nothing) {
                return v;
            };
            if (v2 instanceof Data_Maybe.Just) {
                var $70 = Data_Ord.greaterThan(ordDiffTime)(minus(now)(v.value0))(v1.head.duration);
                if ($70) {
                    return prune(now)(new Animating(plus(v.value0)(v1.head.duration), v2.value0));
                };
                return v;
            };
            throw new Error("Failed pattern match at Animation.Core (line 103, column 7 - line 108, column 19): " + [ v2.constructor.name ]);
        };
        if (v instanceof AnimatingAp) {
            return Data_Exists.runExists(function (v1) {
                var value$prime = prune(now)(v1.value);
                var fn$prime = prune(now)(v1.fn);
                var v2 = getStatic(now)(value$prime);
                var v3 = getStatic(now)(fn$prime);
                if (v3 instanceof Data_Maybe.Just && v2 instanceof Data_Maybe.Just) {
                    return Control_Applicative.pure(applicativeAnimating)(v3.value0(v2.value0));
                };
                if (v3 instanceof Data_Maybe.Just) {
                    return Data_Functor.map(functorAnimating)(v3.value0)(value$prime);
                };
                if (v2 instanceof Data_Maybe.Just) {
                    return Data_Functor.map(functorAnimating)(function (f) {
                        return f(v2.value0);
                    })(fn$prime);
                };
                if (v3 instanceof Data_Maybe.Nothing && v2 instanceof Data_Maybe.Nothing) {
                    return Control_Apply.apply(applyAnimating)(fn$prime)(value$prime);
                };
                throw new Error("Failed pattern match at Animation.Core (line 113, column 9 - line 117, column 44): " + [ v3.constructor.name, v2.constructor.name ]);
            })(v.value0);
        };
        throw new Error("Failed pattern match at Animation.Core (line 100, column 1 - line 100, column 57): " + [ now.constructor.name, v.constructor.name ]);
    };
};
var isStatic = function (t) {
    return function (a) {
        return Data_Maybe.isJust(getStatic(t)(prune(t)(a)));
    };
};
var resolve = function (t) {
    var $91 = unsafeResolve(t);
    var $92 = prune(t);
    return function ($93) {
        return $91($92($93));
    };
};
var animatingSemiring = function (dictSemiring) {
    return new Data_Semiring.Semiring(function (x) {
        return function (y) {
            return Control_Apply.apply(applyAnimating)(Data_Functor.map(functorAnimating)(Data_Semiring.add(dictSemiring))(x))(y);
        };
    }, function (x) {
        return function (y) {
            return Control_Apply.apply(applyAnimating)(Data_Functor.map(functorAnimating)(Data_Semiring.mul(dictSemiring))(x))(y);
        };
    }, Control_Applicative.pure(applicativeAnimating)(Data_Semiring.one(dictSemiring)), Control_Applicative.pure(applicativeAnimating)(Data_Semiring.zero(dictSemiring)));
};
var animate = function (startTime) {
    return function (animation) {
        return new Animating(startTime, animation);
    };
};
module.exports = {
    DiffTime: DiffTime,
    plus: plus,
    minus: minus,
    Animated: Animated,
    singleton: singleton,
    animate: animate,
    "static": $$static,
    resolve: resolve,
    isStatic: isStatic,
    prune: prune,
    newtypeDiffTime: newtypeDiffTime,
    eqDiffTime: eqDiffTime,
    ordDiffTime: ordDiffTime,
    semiringDiffTime: semiringDiffTime,
    newtypeAnimated: newtypeAnimated,
    functorAnimated: functorAnimated,
    animatingSemiring: animatingSemiring,
    functorAnimating: functorAnimating,
    applicativeAnimating: applicativeAnimating,
    applyAnimating: applyAnimating
};
